<template>
  <!-- 打卡详情 -->
  <div class="detail">
    <div class="detail_box">
      <el-card>
        <el-form
          :inline="true"
          ref="search"
          size="small"
          :label-position="labelPosition"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户名字">
                <el-input
                  placeholder="请输入用户名字"
                  v-model="Detaildata.nickName"
                  :disabled="detailOpen"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="地址">
                <el-input
                  placeholder="请输入地址"
                  v-model="Detaildata.address"
                  :disabled="detailOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="打卡类型">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="Detaildata.recordType"
                  :disabled="detailOpen"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in clockType"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="内外勤">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="Detaildata.isInside"
                  :disabled="detailOpen"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in isInsides"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="networkName">
                <el-input
                  placeholder="请输入内容"
                  v-model="Detaildata.networkName"
                  :disabled="detailOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="imeiCode">
                <el-input
                  placeholder="请输入内容"
                  v-model="Detaildata.imeiCode"
                  :disabled="detailOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="打卡时间">
                <el-date-picker
                  v-model="Detaildata.createDate"
                  type="datetime"
                  placeholder="选择日期时间"
                  :disabled="detailOpen"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="打卡说明">
                <el-input
                  placeholder="打卡说明"
                  v-model="Detaildata.remark"
                  :disabled="detailOpen"
                  class="remark"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                label="外勤现场图"
                style="display: flex"
                class="clockImg"
              >
                <viewer :images="photo">
                  <img
                    v-for="(src, index) in photo"
                    :src="src"
                    :key="index"
                    style="width: 200px; height: auto"
                  />
                </viewer>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <el-card>
        <div class="map">
          <div id="container"></div>
        </div>
      </el-card>
    </div>
    <!-- 查看图片 -->
    <a-modal
      :visible="imgOpen"
      @ok="getDelOk"
      @cancel="handleCancel"
      :footer="null"
    >
      <div style="width: 100%; height: 100%">
        <img
          v-if="Detaildata.imgUrl"
          :src="Detaildata.imgUrl"
          alt
          class="imgDa"
        />
      </div>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      photo: [],
      labelPosition: "left",
      backOpen: true, //开关
      backData: "", //返回数据
      imgOpen: false,
      detailOpen: true,
      detailList: "", //详情数据
      ClockUptImg: [], //上传图片
      loadUpt: false, //加载
      latitude: "",
      longitude: "",
      address: "",
      //打卡类型-下拉：;2:
      clockType: [
        {
          label: "4g",
          value: "1",
        },
        {
          label: "wifi",
          value: "2",
        },
      ],
      //   内外勤--下拉：
      isInsides: [
        {
          label: "内勤",
          value: "1",
        },
        {
          label: "外勤",
          value: "2",
        },
      ],
    };
  },
  props: ["Detaildata"],
  methods: {
    handleCancel() {
      this.imgOpen = false;
    },
    getDelOk() {
      this.imgOpen = false;
    },
    init() {
      var map = new AMap.Map("container", {
        zoom: 17, //级别
        mapStyle: "amap://styles/macaron", //设置地图的显示样式
        pitch: 70, // 地图俯仰角度，有效范围 0 度- 83 度
        // viewMode: "3D", // 地图模式
        center: [this.longitude, this.latitude], //中心点坐标
      });
      var marker = new AMap.Marker({
        position: new AMap.LngLat(this.longitude, this.latitude),
        offset: new AMap.Pixel(-10, -10),
        // icon: "//vdata.amap.com/icons/b18/1/2.png", // 添加 Icon 图标 URL
      });
      map.add(marker);

      var title = `<span style="font-size:15px;color:#1890ff;font-weight:bold">${this.address}</span>`;

      var infoWindow = new AMap.InfoWindow({
        anchor: "bottom-left",
        content: title,
      });

      infoWindow.open(map, [this.longitude, this.latitude]);
      map.clearInfoWindow();
      //鼠标点击marker弹出自定义的信息窗体
      AMap.event.addListener(marker, "click", function () {
        infoWindow.open(map, marker.getPosition());
      });
    },
  },
  created() {
    this.latitude = this.Detaildata.latitude;
    this.longitude = this.Detaildata.longitude;
    this.photo.push(this.Detaildata.imgUrl);
    this.address = this.Detaildata.address;
  },
  mounted() {
    this.init(); //获取地图
  },
  watch: {
    Detaildata(newVal, oldVal) {
      this.address = newVal.address;
      this.photo = [];
      this.photo.push(newVal.imgUrl);
      this.latitude = newVal.latitude;
      this.longitude = newVal.longitude;
      this.init();
      //   this.EditList = this.Detaildata;
      // this.getAudioList(); //专辑下的所有音频的列表
      // this.getTypeList(); //获取所有类型的列表
    },
  },
};
</script>
<style scoped lang="less">
.detail {
  width: 100%;
  height: 100%;
  .detail_box {
    width: 95%;
    height: auto;
    margin: 20px auto;
    .el-card {
      margin-top: 15px;
      /deep/ .avatar-uploader {
        width: 200px;
        height: auto;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        outline: 0;
        border: 2px dashed #eee;
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        img {
          width: 100%;
          height: auto;
        }
      }
      .map {
        width: 100%;
        height: 700px;
        #container {
          width: 100%;
          height: 100%;
        }
      }

      /deep/ .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        border-color: #e4e7ed;
        color: #c0c4cc;
        cursor: not-allowed;
        width: 300px;
      }
      /deep/ .clockImg .el-form-item__content {
        display: flex;
        .btn {
          padding: 9px 15px;
          height: 30px;
          margin-top: 170px;
          margin-left: 10px;
          color: #fff;
          background-color: #409eff;
          border-color: #409eff;
          width: 100px;
        }
      }
    }
  }

  //             /deep/ .ant-modal-mask {
  //   .ant-modal-body {
  //     img {

  //     }
  //   }
  // }
}

.imgDa {
  width: 100%;
  height: auto;
}

/deep/ .anticon svg {
  font-size: 30px;
  display: inline-block;
}
/deep/ .remark .el-input__inner {
  width: 720px !important;
}
</style>